import React, { useEffect } from 'react';
import { Alert } from 'housecall-ui';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

import { Cart } from '../../components/Cart/Cart';
import { Layout } from '../../components/Layout';
import { StepProgressBar } from '../../components/StepProgressBar';
import { Codeowners } from '../../consts/codeowners';
import { useChangeStep } from '../../hooks/useChangeStep';
import { useOnlineBookingReducer } from '../../state/useOnlineBookingReducer';
import { captureException } from '../../utils/exception';
import { BackArrowButton } from '../BackArrowButton';

import { PricingFormContentComponent } from './PricingFormContentComponent';

export const PricingFormStep = () => {
  const { dispatch, actions, state } = useOnlineBookingReducer();
  const { pricingForm } = state;
  const { changeStep } = useChangeStep();

  const handleNextClick = () => {
    dispatch(actions.addToCart());
    changeStep('services-troubleshooting');
  };

  useEffect(() => {
    if (!pricingForm) {
      captureException(new Error('PricingFormStep without a pricing form'), Codeowners.CUSTOMER_INTAKE, {}, { state });
    }
  }, [pricingForm, state]);

  const handleBackClick = () => {
    changeStep('categories');
  };

  return (
    <Layout
      Header={
        <>
          <StepProgressBar currentStep={1} stepCount={5} />
          <Cart />
        </>
      }
      ContentComponent={
        <>
          {pricingForm ? (
            <PricingFormContentComponent pricingForm={pricingForm} />
          ) : (
            <>
              <BackArrowButton onClick={handleBackClick} />
              <Alert severity="warning" role="status">
                Something went wrong, please go back or refresh the page.
              </Alert>
            </>
          )}
        </>
      }
      Buttons={
        <Button version="v2" size="medium" fullWidth variant="contained" color="secondary" onClick={handleNextClick}>
          Add to Booking
        </Button>
      }
    />
  );
};
